import React, { useEffect, useState } from 'react'
import SearchContainer from './SearchReviewOrder'
import ReviewPurchaseOrderTable from './ReviewOrderTable'
import useAxios from 'hooks/useAxios';
import { Card, CardBody, Container } from 'reactstrap';
import { getUpdatedFilterLatest } from 'utils/helper';
import useContextService from 'hooks/useContextService';
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ErrorBoundary from 'components/ErrorBoundary';
import Loader from 'components/Loader';
import { cloneDeep } from 'lodash';
import { ToastContainer } from 'react-toastify';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import PunchoutDetails from './PunchoutDetails';
import ReviewOrderOld from 'components/ReviewOrderOld';
let exportflag = "flag";

let filters = [];
const punchdemodata = [
  { podate: '3/06/2025', reason: 'Reason 1', sourcepo: '114566_123', hospitalname: 'Entity 1', acct: '52027810', accntype: 'GPO', potype: 'Pre-Split', wholename: 'Cardinal', postatus: 'Pending Review', updatedDate: '$31723.10', maped: "cell", gcnmaping: "GCN maping", notes: "Notes" },
  { podate: '', reason: 'Reason 2', sourcepo: '104565_UC1625', hospitalname: 'Entity 1', acct: '52027812', accntype: 'WAC', potype: 'Pre-Split', wholename: 'Cardinal', postatus: 'Pending Review', updatedDate: '$2387.48', maped: "cell", gcnmaping: "GCN maping", notes: "Notes" },
  { podate: '', reason: 'Reason 3', sourcepo: '104559_H11425', hospitalname: 'Entity 1', acct: '52042747', accntype: 'GPO', potype: 'Pre-Split', wholename: 'Cardinal', postatus: 'Pending Review', updatedDate: '16325.26', maped: "cell", gcnmaping: "GCN maping", notes: "Notes" },
  { podate: '', reason: 'Reason 4', sourcepo: '104564_H0116', hospitalname: 'Entity 1', acct: '52027810', accntype: 'GPO', potype: 'Pre-Split', wholename: 'Cardinal', postatus: 'Pending Review', updatedDate: '54325.77', maped: "cell", gcnmaping: "GCN maping", notes: "Notes" },
  { podate: '', reason: 'Reason 5', sourcepo: '104563_UC1525', hospitalname: 'Entity 1', acct: '52027810', accntype: 'GPO', potype: 'Pre-Split', wholename: 'Cardinal', postatus: 'Pending Review', updatedDate: '26640.39', maped: "cell", gcnmaping: "GCN maping", notes: "Notes" },
  { podate: '', reason: 'Reason 6', sourcepo: '104546_HG1825', hospitalname: 'Entity 1', acct: '52042747', accntype: 'GPO', potype: 'Pre-Split', wholename: 'Cardinal', postatus: 'Pending Review', updatedDate: '9687.16', maped: "cell", gcnmaping: "GCN maping", notes: "Notes" },
  { podate: '', reason: 'Reason 7', sourcepo: '104551_H0110c', hospitalname: 'Entity 1', acct: '52027812', accntype: 'WAC', potype: 'Pre-Split', wholename: 'Cardinal', postatus: 'Pending Review', updatedDate: '19600.28', maped: "cell", gcnmaping: "GCN maping", notes: "Notes" },

];
const detaildata = [
  { ordervalue: '', itemNumber: '776162', ndc: '43353054760', drugName: 'DIVALPROEX SOD ER 500 MG TAB', package: "90", manufacture: "Aphena Pharma", totalpkgs: '80', accumulations340B: '30', pkg340B: '30', pricePkgs340B: "$8.04", total340BPrice: "$241.20", gpoAccumulations: 20, gpoPkgs: "20", gpoPricePkgs: "$102.45", totalGPOPrice: "$2049.00", wacPkgs: "30", wacPricePack: "$190.26", totalWACPrice: "$5707.80", totalspend: "$7998.00" },
  { ordervalue: '', itemNumber: '781283', ndc: '55150015521', drugName: 'ACYCLOVIR 1,000 MG/20 ML VIAL', package: "20", manufacture: "Auromedics Pharma", totalpkgs: '60', accumulations340B: '20', pkg340B: '20', pricePkgs340B: "$34.15", total340BPrice: "$683.00", gpoAccumulations: 10, gpoPkgs: "20", gpoPricePkgs: "$68.23", totalGPOPrice: "$682.30", wacPkgs: "30", wacPricePack: "$82.41", totalWACPrice: "$2472.30", totalspend: "$3837.60" },
  { ordervalue: '', itemNumber: '427366', ndc: '24208091055', drugName: 'ERYTHROMYCIN EYE OINTMENT 5MG/GM', package: "3.5", manufacture: "Bausch & Lomb", totalpkgs: '40', accumulations340B: '10', pkg340B: '10', pricePkgs340B: "$4.42", total340BPrice: "$44.20", gpoAccumulations: 10, gpoPkgs: "10", gpoPricePkgs: "$9.90", totalGPOPrice: "$99.00", wacPkgs: "30", wacPricePack: "$184.96", totalWACPrice: "3699.20", totalspend: "$3842.40" },
];

const ReviewPurchaseOrder = (props) => {
  const { orgId, reset, setkey, loading,
    setLoading, tabKey } = props;
  const API = useAxios();
  const {
    states: { reviewOrder },
    setStates,
  } = useContextService();
  const { search, coveredEntity, searchTerms, claimStatusID } = reviewOrder;
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const [totalitem, setTotalItem] = useState(0);
  const [openEditOrder, setOpenEditOrder] = useState(false);
  const [collapseSider, setcollapseSider] = useState(false);
  const [collIcon, setCollIcon] = useState(faAngleUp);
  const [rowData, setrowData] = useState('');
  // const [loading, setLoading] = useState(false);
  const [demodata, setDemoData] = useState([]);
  const [userRoles, setUserRoles] = useState([]);
  const [resetFilterFlag, SetResetFilterFlag] = useState(false);
  const [key, setKey] = useState('punchout');
  useEffect(() => {
    if (searchTerms.coveredEntityID) handleSearch(searchTerms);
    onReset();
  }, []);
  const { token_type, access_token, profile } =
    JSON.parse(localStorage.getItem('pharmaforce')) || {};
  const { sub, roles } = profile || {};
  useEffect(() => {
    if (Array.isArray(roles)) {
      setUserRoles(roles);
    }
    else {
      var obj = [];
      obj.push(roles);
      setUserRoles(obj);
    }
  }, [roles])

  useEffect(() => {
    onReset();
  }, [orgId, reset]);

  const manvalConfigedit = (rowData) => {
    setrowData(rowData);
    setOpenEditOrder(!openEditOrder);
  }

  const refetch = (hasTrue) => {
    let filter = {}
    setColumnFilters([]);
    filter.accumulationIDs = [searchTerms.accumulationIDs[0].value];
    handleSearch(filter);
  };
  const onReset = () => {
    debugger
    setcollapseSider(false);
    setData([]);
    setTotalItem(0);
    SetResetFilterFlag(true);
    setColumnFilters([]);
  };
  const handleSearch = async (filter) => {
    const {
      accumulationIDs,


    } = filter;

    // if (orderStatusId) {
    //   filters = getUpdatedFilterLatest(
    //         'poStatusID',
    //         (orderStatusId),
    //         filters
    //     );
    // }
    const tableRes = document.querySelector('.table-responsive');
    tableRes.scrollLeft = 0;
    //search.filters = filters;
    //search.ChainPharmacyIDs = cpIds;
    search.AccumulatorIDs = accumulationIDs;
    await fetchReviewOrders(search);
  };
  const fetchReviewOrders = async (filters) => {
    debugger;
    if (!(orgId?.tenantID)) return null;
    if (window.selectedCoveredEntittyId == "" || window.selectedCoveredEntittyId == undefined) return null;
    //setData([]);
    try {
      setLoading(true)
      {
        const { data } = await API.post(`SBTenant/${orgId.tenantID}/PurchaseOrder/GetReviewOrderAll/${exportflag}`, filters,
          { hasDefaultURL: true, }
        )
        if (data?.items?.length > 0) {
          setData(data?.items);
          setData1(detaildata)
          // setcollapseSider(true);
          setCollIcon(faAngleDown);

          setTotalItem(data.totalRecords);
          setDemoData(punchdemodata);
          setLoading(false);

        } else {
          setData([]);
          setTotalItem(0);
          setLoading(false)
        }
      }
    } catch (error) {
      setLoading(false)
    }
  };
  const handlePageChange = (filter, haveColFilter) => {
    if (haveColFilter) {
      const filterObj = cloneDeep(search);
      filterObj.filters = [...filterObj.filters, ...filter.filters];
      filterObj.currentPage = filter.currentPage;
      filterObj.pageSize = filter.pageSize;
      filterObj.orderBy = filter.orderBy;
      filterObj.order = filter.order;

      reviewOrder.search.currentPage = filter.currentPage;
      reviewOrder.search.pageSize = filter.pageSize;
      reviewOrder.search = { ...reviewOrder.search };
      fetchReviewOrders(filterObj);

    } else {
      fetchReviewOrders(filter);
      reviewOrder.search = { ...reviewOrder.search, ...filter };
    }
    setStates('reviewOrder', reviewOrder);
  };
  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    }
    else {
      setCollIcon(faAngleUp);
    }
  }
  const handleSearchColumnFilters = async (columnFilters) => {
    const filterObj = cloneDeep(search);
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
      setColumnFilters(columnFilters)
    }
    reviewOrder.search.currentPage = 1;
    filterObj.currentPage = 1;
    await fetchReviewOrders(filterObj);
  };

  const handleExport = async () => {

    const filterObj = cloneDeep(search);
    //filterObj.ActiveButton = ActiveButton
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
    }

    const { access_token } =
      JSON.parse(localStorage.getItem('pharmaforce')) || {};

    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    additionalCriteria.OrgId = orgId.organizationID;
    // additionalCriteria.ContractId = 0;
    // additionalCriteria.POId = 0;
    // additionalCriteria.OpaId = 0;
    // additionalCriteria.CEId = 0;
    // additionalCriteria.ManufactureId = 0;

    var payload = {};
    payload.tenantID = orgId.tenantID
    payload.gridCode = "reviewOrder";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
    //  const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${orgId.tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
    //  onExport(action, initialFilters);
  };
  const handleTabChange = async (value) => {
    setKey(value);
  };
  return (
    <div>

      <div>
        {/* <Container fluid className='width_info bin_info'> */}
        <div>
          <Card className='border-0 shadow-top durg_tabs mb-3'>
            <CardBody hidden={collapseSider} className=''>
              <ErrorBoundary >
                <SearchContainer
                  orgId={orgId}
                  reset={reset}
                  onReset={onReset}
                  onSearch={handleSearch}
                  data={data}
                  loading={loading}
                  tabKey={tabKey}
                  setLoading={setLoading}
                />                </ErrorBoundary>
            </CardBody>
          </Card>
        </div>
        <Card className='border-0 shadow-top ' hidden={!(userRoles.includes('SBPFADM') || userRoles.includes('SUPADM'))}>
          <CardBody>
            {/* <Container fluid className='my-3 bin_info'> */}
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => handleTabChange(k)}
              className="mb-3"
            >
              <Tab eventKey="punchout" title="Punchout List">
                {/* <div className="py-2 text-center">
                            <span style={{ fontSize: "27px", cursor: "pointer", }} onClick={toggleSider}>
                                <FontAwesomeIcon icon={collIcon} className="fa-fw" />
                            </span>
                        </div> */}
                <ErrorBoundary>
                  <PunchoutDetails collapseSider={collapseSider} demodata={demodata} setDemoData={setDemoData} setKey={setKey} key={key} />
                </ErrorBoundary>
              </Tab>
              <Tab eventKey="Details" title="Details">
                {/* <div className="py-2 text-center">
                            <span style={{ fontSize: "27px", cursor: "pointer", }} onClick={toggleSider}>
                                <FontAwesomeIcon icon={collIcon} className="fa-fw" />
                            </span>
                        </div> */}
                <ErrorBoundary>
                  <ReviewPurchaseOrderTable
                  setDemoData = {setDemoData}
                  setData1 ={setData1}
                    tabKey={tabKey}
                    data={data1}
                    filters={search}
                    onExport={handleExport}
                    totalitem={totalitem}
                    loading={loading}
                    setLoading={setLoading}
                    manvalConfigedit={manvalConfigedit}
                    rowData={rowData}
                    orgId={orgId}
                    onPageChange={handlePageChange}
                    refetch={refetch}
                    onSearchColumnFilters={handleSearchColumnFilters}
                    collapseSider={collapseSider}
                    toggleSider={toggleSider}
                    resetFilterFlag={resetFilterFlag}
                    SetResetFilterFlag={SetResetFilterFlag}
                  />
                </ErrorBoundary>
              </Tab>
            </Tabs>
          </CardBody>
          {/* </Container> */}
        </Card>
        <Card className='border-0 shadow-top' hidden={(userRoles.includes('SBPFADM') || userRoles.includes('SUPADM'))}>
          <CardBody className="">
            <div className="py-0 text-center">
              <span
                style={{ fontSize: "27px", cursor: "pointer" }}
                onClick={toggleSider}
              >
                <FontAwesomeIcon icon={collIcon} className="fa-fw" />
              </span>
            </div>
            <ErrorBoundary>
              <ReviewOrderOld
                tabKey={tabKey}
                data={data}
                filters={search}
                onExport={handleExport}
                totalitem={totalitem}
                // loading={loading}
                // setLoading = {setLoading}
                manvalConfigedit={manvalConfigedit}
                rowData={rowData}
                orgId={orgId}
                onPageChange={handlePageChange}
                refetch={refetch}
                onSearchColumnFilters={handleSearchColumnFilters}
                collapseSider={collapseSider}
                toggleSider={toggleSider}
                setkey={setkey}
                resetFilterFlag={resetFilterFlag}
                SetResetFilterFlag={SetResetFilterFlag}
              />
            </ErrorBoundary>
          </CardBody>
        </Card>
      </div>
    </div>
    // <div>
    //   <div className='border-0'>
    //     <Card className="border-0 shadow-top mb-3 durg_tabs">
    //       <CardBody hidden={collapseSider} className="">
    //       <div hidden={collapseSider} className=''>
    //         <ErrorBoundary>
    //           <SearchContainer
    //             orgId={orgId}
    //             reset={reset}
    //             onReset={onReset}
    //             onSearch={handleSearch}
    //             data={data}
    //             loading={loading}
    //           />
    //         </ErrorBoundary>
    //         </div>
    //       </CardBody>
    //     </Card>
    //     <Card className='border-0 shadow-top'>
    //       <CardBody className="">
    //         {/* <div className="py-0 text-center">
    //           <span
    //             style={{ fontSize: "27px", cursor: "pointer" }}
    //             onClick={toggleSider}
    //           >
    //             <FontAwesomeIcon icon={collIcon} className="fa-fw" />
    //           </span>
    //         </div> */}
    //         <ErrorBoundary>
    //           <ReviewPurchaseOrderTable
    //             data={data}
    //             filters={search}
    //             onExport={handleExport}
    //             totalitem={totalitem}
    //             loading={loading}
    //             setLoading = {setLoading}
    //             manvalConfigedit={manvalConfigedit}
    //             rowData={rowData}
    //             orgId={orgId}
    //             onPageChange={handlePageChange}
    //             refetch={refetch}
    //             onSearchColumnFilters={handleSearchColumnFilters}
    //             collapseSider={collapseSider}
    //               toggleSider={toggleSider}
    //           />
    //         </ErrorBoundary>
    //       </CardBody>
    //     </Card>
    //   </div>
    // </div>
  );
}

export default ReviewPurchaseOrder
